import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'
import DeleteAccount from '../components/DeleteAccount'
import Login from '../components/Login'
import Register from '../components/Register'
import RegisterMonitor from '../components/RegisterMonitor'

import Dashboard from '../components/Dashboard'
import SurveysManagement from '../components/SurveysManagement'
import SurveyForm from '../components/SurveyForm'
import Questions from '../components/Questions'
import Results from '../components/Results'
import Result from '../components/Result'

import Users from '../components/Users'
import Monitors from '../components/Monitors'
import TestManagement from '../components/TestManagement'
import Countries from '../components/Countries'
import Dictionaries from '../components/Dictionaries'
import Test from '../components/Test'

Vue.use(VueRouter)

const title = 'Pesticide Action Network UK'

const routes = [
  {
    path: '/delete-account',
    name: 'Delete Account',
    component: DeleteAccount,
    meta: {
      title: 'Delete Account - ' + title,
      hideHeader: true
    },
  }, {
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login - ' + title,
      hideHeader: true
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: 'Register - ' + title,
      hideHeader: true
    },
  },
  {
    path: '/register/monitor',
    name: 'RegisterMonitor',
    component: RegisterMonitor,
    meta: {
      title: 'Register - ' + title,
      hideHeader: true
    },
  },
  {
    path: '/test/:hash',
    name: 'Test',
    component: Test,
    props: true,
    meta: {
      title: 'Test - ' + title,
      hideHeader: true
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: 'Dashboard - ' + title,
    },
  },
  {
    path: '/surveys',
    name: 'SurveysManagement',
    component: SurveysManagement,
    meta: {
      title: 'Surveys Management - ' + title,
    },
  },
  {
    path: '/surveys/create',
    name: 'SurveyCreateForm',
    component: SurveyForm,
    meta: {
      title: 'Create Survey - ' + title,
    },
  },
  {
    path: '/surveys/:id',
    name: 'SurveyEditForm',
    component: SurveyForm,
    meta: {
      title: 'Edit Survey - ' + title,
    },
    props: true
  },
  {
    path: '/questions',
    name: 'Questions',
    component: Questions,
    meta: {
      title: 'Survey QA List - ' + title,
    },
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      title: 'Users - ' + title,
    },
  },
  {
    path: '/monitors',
    name: 'Monitors',
    component: Monitors,
    meta: {
      title: 'Monitors - ' + title,
    },
  },
  {
    path: '/test-management',
    name: 'TestManagement',
    component: TestManagement,
    meta: {
      title: 'Test Management - ' + title,
    },
  },
  {
    path: '/countries',
    name: 'Countries',
    component: Countries,
    meta: {
      title: 'Regions - ' + title,
    },
  },
  {
    path: '/pesticides',
    name: 'Pesticides',
    component: Dictionaries,
    meta: {
      title: 'Pesticides - ' + title,
    },
  },
  {
    path: '/active_ingredients',
    name: 'Active Ingredients',
    component: Dictionaries,
    meta: {
      title: 'Active Ingredients - ' + title,
    },
  },
  {
    path: '/crops',
    name: 'Crops',
    component: Dictionaries,
    meta: {
      title: 'Crops - ' + title,
    },
  },
  {
    path: '/pests',
    name: 'Pests',
    component: Dictionaries,
    meta: {
      title: 'Pests - ' + title,
    },
  },
  {
    path: '/organs',
    name: 'Organ Systems',
    component: Dictionaries,
    meta: {
      title: 'Organ Systems - ' + title,
    },
  },
  {
    path: '/results',
    name: 'Surveys Completed',
    component: Results,
    meta: {
      title: 'Surveys Completed - ' + title,
    },
  },
  {
    path: '/results/:id',
    name: 'Survey Report',
    component: Result,
    meta: {
      title: 'Survey Report - ' + title,
    },
    props: true,
  },
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
router.beforeEach((to, from, next) => {
  if (to.name === 'Login') {
    if (store.state.auth.token && store.state.auth.user.id) next({ name: 'Dashboard' })
    else next()
  }
  else if (to.name === 'Delete Account') {
    next()
  } else {
    if (!store.state.auth.token || !store.state.auth.user.id) next({ name: 'Login' })
    document.title = to.meta.title
    next()

  }
})
